let cachedCards = null;
let cachedByColumn = new Map();

export default {
  pipelines: state => state.pipelines,
  salesPipelines: state => state.pipelines.filter(p => p.category === 'sales'),
  activePipeline: state =>
    state.pipelines.find(p => p.id === state.activePipelineId),
  cardsByColumn: state => columnId => {
    if (state.cards !== cachedCards) {
      cachedCards = state.cards;
      cachedByColumn = new Map();
    }
    if (!cachedByColumn.has(columnId)) {
      cachedByColumn.set(
        columnId,
        state.cards.filter(c => c.column_id === columnId)
      );
    }
    return cachedByColumn.get(columnId);
  },
  uiFlags: state => state.uiFlags,
};
